import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';
import { useTranslation } from "react-i18next";

function VisaPrepAdditionalPersonalInfoStep1_2(props: IVisaPrepForm) {
    const { t } = useTranslation('forms.visa');
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.RESIDENTIAL_ADDRESS_START_DATE}
        label={t('forms.visa:residentialStartDate')}
        fullLabel={`When did you start living at your current permanent residential address?`}
        value={props.residentialAddressStartDate}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HOME_OWNERSHIP_STATUS}
        label={t('forms.visa:ownershipStatus')}
        fullLabel={`What is the ownership status of your home?`}
        value={props.homeOwnershipStatus}
      />
      {props.homeOwnershipStatus === 'Other' ? (
        <SummaryRow
          className={'visa-summary'}
          key={VQ.HOME_OWNERSHIP_STATUS}
          label={t('forms.visa:ownershipStatusOther')}
          value={props.homeOwnershipStatusOther}
        />
      ) : null}
      <SummaryRow
        className={'visa-summary'}
        key={VQ.HAS_DIFFERENT_CONTACT_DETAILS}
        label={t('forms.visa:hasDifferentPreferredContactDeta')}
        fullLabel={`Are your preferred contact details different from the contact details already provided above?`}
        value={boolToYesNo(props.hasDifferentContactDetails)}
      />
      {props.hasDifferentContactDetails ? (
        <>
          <SummaryRow
            className={'visa-summary'}
            key={VQ.DIFF_CONTACT_ADDRESS}
            label={t('forms.visa:contactAddress2')}
            value={props.diffContactAddress}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.DIFF_CONTACT_CITY}
            label={t('forms.visa:city')}
            value={props.diffContactCity}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.DIFF_CONTACT_POSTCODE}
            label={t('forms.visa:postcode')}
            value={props.diffContactPostcode}
          />
          <SummaryRow
            className={'visa-summary'}
            key={VQ.DIFF_CONTACT_COUNTRY}
            label={t('forms.visa:country')}
            value={props.diffContactCountry}
          />
        </>
      ) : null}
    </>
  );
}

export default VisaPrepAdditionalPersonalInfoStep1_2;
